import { render, staticRenderFns } from "./ResourcePage.vue?vue&type=template&id=263de221"
import script from "./ResourcePage.vue?vue&type=script&lang=js"
export * from "./ResourcePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports